"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.ConfiguratorColourSelector = void 0;
var _configuratorColourSelector = _interopRequireDefault(require("./components/configurator-colour-selector"));
exports.ConfiguratorColourSelector = _configuratorColourSelector["default"];